import { Address } from 'viem'
import type { YieldSource } from '../types'

export function makeYieldOpportunityId(source: YieldSource, chainId: number, address: Address): string {
  return `${source}-${chainId}-${address.toLowerCase()}`
}
